import { CrudService } from './crud.service';

export class PasswordResetService {
  private crudService: CrudService<string>;

  constructor() {
    this.crudService = new CrudService<any>('login/reset-password');
  }

  public async resetPasswordFromUsername(username: string): Promise<string> {
    const { model } = await this.crudService.do('POST', '', { username });
    return model.messageCode;
  }

  public async setPassword(username: string, newPassword: string, token: string): Promise<string> {
    const params = new URLSearchParams();
    params.set('username', username);

    try {
      const { model } = await this.crudService.do(
        'PUT',
        `${token}?${params.toString()}`,
        { newPassword },
        undefined,
        'throw',
      );
      return model.messageCode;
    } catch (e: any) {
      if (e.response && e.response.data && e.response.data.messageCode) {
        throw new Error(e.response.data.messageCode);
      }
      throw new Error('backend.login.password_reset_failed_unknown');
    }
  }
}
